/**
 * Contextual help "?" button (AUTONOMY · Layer 2/3).
 *
 * Placed in the headers of the main screens, it leads to the section
 * of the in-app guide documenting that area (`AREA_HELP`). URL-addressable:
 * `/help/<guide>?section=<section>`.
 */
import { Show } from "solid-js";
import { msg } from "@lingui/core/macro";
import { CircleHelp } from "@fleet/icons";

import { useI18n } from "@/providers/i18n-provider";
import { Link } from "@tanstack/solid-router";
import { helpTargetForArea } from "../registry";

export function HelpButton(props: { area: string; class?: string }) {
  const { t } = useI18n();
  const target = () => helpTargetForArea(props.area);
  return (
    <Show when={target()}>
      {(resolved) => (
        <Link
          to="/help/$guideSlug"
          params={{ guideSlug: resolved().guide }}
          search={{ section: resolved().section }}
          aria-label={t(msg`Help for this screen`)}
          title={t(msg`Help for this screen`)}
          data-testid={`help-button-${props.area}`}
          class={`inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-muted-foreground transition-colors hover:bg-accent/10 hover:text-accent ${props.class ?? ""}`}
        >
          <CircleHelp class="h-5 w-5" />
        </Link>
      )}
    </Show>
  );
}
